export default "__VITE_ASSET__DehMhMbR__"